export enum EntityStoreKey {
  candidate = 'candidate',
}

export const enum CandidateErrorCode {
  CannotAssignAdminWithoutAccess = 'cannot_assign_admin_without_access',
}
